import React from 'react';
import { motion } from 'framer-motion';
import { Music } from 'lucide-react';

const Loading = () => {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center"
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4"
        >
          <Music className="w-8 h-8 text-white" />
        </motion.div>
        <h2 className="text-xl font-semibold text-white mb-2">Loading JukeHive</h2>
        <p className="text-gray-400">Getting everything ready...</p>
      </motion.div>
    </div>
  );
};

export default Loading; 